/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-21T19:19:46-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-17T17:11:18-07:00
*/



import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { spacing, type, textColor, dimensions } from '../../style';

const style = StyleSheet.create({
  headline: {
    fontWeight: 'normal',
    ...type.title.SM,
    ...textColor.DARKER,
  },

  size_XS: {
    ...type.title.XS,
  },

  size_SM: {
    ...type.title.SM,
  },

  size_MD: {
    ...type.title.MD,
  },

  size_LG: {
    ...type.title.LG,
  },

  subHead: {
    fontWeight: 'normal',
    ...spacing.MARGIN_TOP_XS,
    ...textColor.NORMAL
  },

  invertedColor: {
    color: '#fff'
  },

  spaceAfter: {
    ...spacing.MARGIN_BOTTOM_MD
  }

});


const Headline = (props) => {
  const {
    subhead,
    hasDescription,
    invertedColor,
    size,
    children,
    extraStyles,
    spaceAfter,
    ...rest
  } = props

  return (
    <div
      style={{...extraStyles}}
      className={ css(
        subhead ? style.subHead : style.headline,
        invertedColor && style.invertedColor,
        spaceAfter && style.spaceAfter,
        size && style[`size_${size}`]
      )}>
      {children}
    </div>
  )
}



export default Headline;



// WEBPACK FOOTER //
// ./src/components/common/Headline.jsx